<template>
  <div>
    <v-form ref="formQA">
      <fieldset v-if="stato === 'started'" id="qa-fieldset">
        <div class="contenitore-domande">
          <!-- Vengono mostrate solo le domande per la schermata attuale -->
          <!-- v-if="domandaConRisposte.schermata == schermataAttuale" -->
          <!-- Nel seguente ho sostituito v-if con v-show, altrimenti i 'ref=..' presenti negli input vengono persi quando si cambia schermata e durante la verifica non funzionano più  -->
          <div
            v-for="(domandaConRisposte, indice) in domandeConRisposte"
            v-show="domandaConRisposte.schermata == schermataAttuale"
            :key="domandaConRisposte.uid"
            :id="domandaConRisposte.uid"
            :class="`${domandaConRisposte.rispostaNonCorretta ? 'errore ' : ''} form-elem xs-12 md-6`"
          >
            <!-- Mostro il label se il tipo di domandaConRisposte richiede l'etichetta -->
            <label v-if="!nonRichiedeEtichetta(domandaConRisposte.tipo)">
              {{ domandaConRisposte.domanda }}: *
            </label>

            <!-- Tipi testuali: validate_text, unpastable, monochar, text, select, .. -->
            <v-row no-gutters style="margin-top: 8px;" v-if="['validate_text', 'unpastable', 'monochar', 'text', 'reverse', 'select', 'data'].includes(domandaConRisposte.tipo)">
              <div class="d-flex">
                <!-- Suddivido la risposta corretta nelle parti statiche e editabili -->
                <div v-for="(parte, idx) in ottieniPartiStringa(risposteCorrette[domandaConRisposte.uid])" :key="domandaConRisposte.uid + '_' + idx">
                  
                  <!-- Tipo "validate_text" -->
                  <template v-if="domandaConRisposte.tipo === 'validate_text'">
                    <span v-if="parte.traGraffeQuindiStatico" style="font-size: 24px; line-height: 1.5;">
                      {{ parte.contenuto }}
                    </span>
                    <input
                      v-else
                      :ref="domandaConRisposte.uid"
                      type="text"
                      :name="`risposte[${indice}]`"
                      class="form-control"
                      autocomplete="off"
                      tabindex="1"
                      style="width: 150px;"
                      v-model="risposteUtenteGrezze[domandaConRisposte.uid]"
                    >
                  </template>

                  <!-- Tipo "unpastable" (impedisce il paste) -->
                  <template v-else-if="domandaConRisposte.tipo === 'unpastable'">
                    <span v-if="parte.traGraffeQuindiStatico" style="font-size: 24px; line-height: 1.5;">
                      {{ parte.contenuto }}
                    </span>
                    <input
                      v-else
                      :ref="domandaConRisposte.uid"
                      type="text"
                      :name="`risposte[${indice}]`"
                      class="form-control"
                      autocomplete="off"
                      tabindex="1"
                      @paste.prevent
                      v-model="risposteUtenteGrezze[domandaConRisposte.uid]"
                    >
                  </template>

                  <!-- Tipo "monochar": una serie di input per ogni carattere -->
                  <template v-else-if="domandaConRisposte.tipo === 'monochar'">
                    <div style="display: inline-flex; gap: 4px;">
                      <span v-if="parte.traGraffeQuindiStatico" style="font-size: 24px; line-height: 1.5;">
                        {{ parte.contenuto }}
                      </span>
                      <div v-else style="display:inline" v-for="(carattere, i) in parte.contenuto.split('')" :key="i">
                        <!-- Le monochar non sono associate ad alcun v-model (vengono gestite solo tramite ref):
                        quindi hanno bisogno di chiamare manualmente la funzione di trasformazione da grezze a finali
                        tramite @change="..." -->
                        <input
                          :ref="domandaConRisposte.uid"
                          type="text"
                          minlength="1"
                          maxlength="1"
                          size="1"
                          pattern="[A-Za-z0-9]{1}"
                          style="text-align: center; font-size: 18px; width: 44px;"
                          @change="setRisposteUtenteFinaliDaGrezze"
                        >
                        <!-- I monochar possono essere gestiti (ricompattando la stringa) tramite ref -->
                        <!-- v-model="risposteMonochar[domandaConRisposte.uid][i]" -->
                      </div>
                    </div>
                  </template>

                  <!-- Tipo "text": input testo standard -->
                  <template v-else-if="domandaConRisposte.tipo === 'text'">
                    <span v-if="parte.traGraffeQuindiStatico" style="font-size: 24px; line-height: 1.5;">
                      {{ parte.contenuto }}
                    </span>
                    <input
                      v-else
                      :ref="domandaConRisposte.uid"
                      type="text"
                      :name="`risposte[${indice}]`"
                      class="form-control"
                      autocomplete="off"
                      tabindex="1"
                      v-model="risposteUtenteGrezze[domandaConRisposte.uid]"
                    >
                  </template>

                  <!-- Tipo "reverse": l'utente dovrà inserire la risposta al contrario -->
                  <template v-else-if="domandaConRisposte.tipo === 'reverse'">
                    <span v-if="parte.traGraffeQuindiStatico" style="font-size: 24px; line-height: 1.5;">
                      {{ parte.contenuto }}
                    </span>
                    <input
                      v-else
                      :ref="domandaConRisposte.uid"
                      type="text"
                      :name="`risposte[${indice}]`"
                      class="form-control"
                      autocomplete="off"
                      tabindex="1"
                      v-model="risposteUtenteGrezze[domandaConRisposte.uid]"
                    >
                  </template>

                  <!-- Tipo "select": menu a tendina -->
                  <template v-else-if="domandaConRisposte.tipo === 'select'">
                    <span v-if="parte.traGraffeQuindiStatico" style="font-size: 24px; line-height: 1.5;">
                      {{ parte.contenuto }}
                    </span>
                    <select
                      v-else
                      :ref="domandaConRisposte.uid"
                      :name="domandaConRisposte.uid"
                      style="-webkit-appearance: menulist; -moz-appearance: menulist; appearance: menulist;"
                      tabindex="1"
                      v-model="risposteUtenteGrezze[domandaConRisposte.uid]"
                    >
                      <option value="" disabled selected hidden></option>
                      <option v-for="risp in domandaConRisposte.risposteShuffled" :value="risp">
                        {{ risp }}
                      </option>
                    </select>
                  </template>

                </div>
                
                <!-- Tipo "data": selettore date apposito -->
                <!-- Tipo "data": input date -->
                <template v-if="domandaConRisposte.tipo === 'data'">
                  <input
                    :ref="domandaConRisposte.uid"
                    type="date"
                    v-model="risposteUtenteGrezze[domandaConRisposte.uid]"
                    :name="domandaConRisposte.uid"
                    class="form-control"
                    autocomplete="off"
                    tabindex="1"
                  >
                </template>

                <!-- Pulsante di convalida per il tipo "validate_text" -->
                <v-btn
                  v-if="domandaConRisposte.tipo === 'validate_text'"
                  @click="convalidaTesto(indice)"
                  :style="(domandaConRisposte.rispostaValidata ? 'background-color: #4A4846;' : 'background-color: #4A4846;') + ' color: white; border-radius: 0; margin-left: 50px;'"
                >
                  Convalida
                </v-btn>
              </div>
            </v-row>

            <!-- Tipo "radio": input radio standard -->
            <template v-else-if="domandaConRisposte.tipo === 'radio'">
              <v-row no-gutters>
                <template>
                  <v-col cols="12" v-for="(risp, idxRadio) in domandaConRisposte.risposteShuffled" :key="idxRadio">
                    <div>
                      <input
                        :ref="domandaConRisposte.uid"
                        type="radio"
                        :id="`${domandaConRisposte.uid}_${idxRadio}`"
                        :value="risp"
                        v-model="risposteUtenteGrezze[domandaConRisposte.uid]"
                        :name="domandaConRisposte.uid"
                      >
                      <label class="radio-label" :for="`${domandaConRisposte.uid}_${idxRadio}`">{{ risp }}</label>
                    </div>
                  </v-col>
                </template>
              </v-row>
            </template>

            <!-- Tipo "radio3": radio disposti su 3 colonne -->
            <template v-else-if="domandaConRisposte.tipo === 'radio3'">
              <v-row no-gutters>
                <template>
                  <v-col cols="4" v-for="(risp, idxRadio) in domandaConRisposte.risposteShuffled" :key="idxRadio">
                    <div>
                      <input
                        :ref="domandaConRisposte.uid"
                        type="radio"
                        :id="`${domandaConRisposte.uid}_${idxRadio}`"
                        :value="risp"
                        v-model="risposteUtenteGrezze[domandaConRisposte.uid]"
                        :name="domandaConRisposte.uid"
                      >
                      <label class="radio-label" :for="`${domandaConRisposte.uid}_${idxRadio}`">{{ risp }}</label>
                    </div>
                  </v-col>
                </template>
              </v-row>
            </template>

            <!-- Tipi checkbox (compresi checkbox_bloccante e checkbox_reverse) -->
            <template v-else-if="['checkbox', 'checkbox_bloccante', 'checkbox_reverse'].includes(domandaConRisposte.tipo)">
              <input
                :ref="domandaConRisposte.uid"
                type="checkbox"
                v-model="risposteUtenteGrezze[domandaConRisposte.uid]"
                :id="`${domandaConRisposte.uid}_${indice}`"
                @change="domandaConRisposte.tipo == 'checkbox_bloccante' ? controllaCheckboxBloccantiSchermataAttuale($event) : null"
              >
                <!-- :name="domandaConRisposte.uid" -->
              <label :for="`${domandaConRisposte.uid}_${indice}`">{{ domandaConRisposte.domanda }} *</label>
            </template>

            <!-- Tipo "summary": riepilogo dati inseriti -->
            <div v-else-if="domandaConRisposte.tipo === 'summary'">
              <div style="font-size: 18px; margin-bottom: 10px">Riepilogo dati inseriti</div>
              <div class="mb-3">
                <!-- <div
                  v-for="(item, i) in datiRiepilogo(domandaConRisposte)" :key="i"
                  class="mb-3"
                > -->
                <div class="mb-3" v-for="(item, i) in datiRiepilogo()" :key="i">
                  <span class="font-weight-bold mr-2">{{ item.domanda }}:</span>
                  <span>
                    {{
                      typeof item.rispostaUtenteFinale === 'boolean'
                        ? (item.rispostaUtenteFinale ? 'Si' : 'No')
                        : item.rispostaUtenteFinale
                    }}
                  </span>
                </div>
              </div>
              <div class="font-weight-bold mt-6">
                Informativa: I dati inseriti potrebbero essere oggetto di verifica durante la lavorazione della domanda.
              </div>
              <div class="mb-6">
                <input
                  type="checkbox"
                  :id="`${domandaConRisposte.uid}_${indice}`"
                  v-model="risposteUtenteGrezze[domandaConRisposte.uid]"
                  :name="domandaConRisposte.uid"
                >
                <label :for="`${domandaConRisposte.uid}_${indice}`">Accetto *</label>
              </div>
              <!-- <div> -->
                <!-- Cliccare sul pulsante <span class="font-weight-bold">Indietro</span> per modificare i dati inseriti<br> -->
                <!-- Cliccare sul pulsante <span class="font-weight-bold">{{ tastoContinuaVisibile ? 'Continua' : 'Invia'}}</span> per confermare ed inviare la domandaConRisposte -->
              <!-- </div> -->
            </div>

          </div>
        </div>
      </fieldset>
    </v-form>

    <v-snackbar
      v-model="validateTextVerificatoCorrettamente"
      :timeout="3000"
      top
      right
      color="success"
    >
      Campo verificato correttamente
    </v-snackbar>
    <v-snackbar
      v-model="erroriNelleRisposteSnackbar"
      :timeout="3000"
      top
      right
      color="error"
    >
      Tutti gli input richiesti non sono compilati correttamente.
    </v-snackbar>
    <v-snackbar
      v-model="campiNonValidatiSnackbar"
      :timeout="3000"
      top
      right
      color="error"
    >
      Campo non validato
    </v-snackbar>
    <v-snackbar
      v-model="simulazioneNonPartitaSnackbar"
      :timeout="3000"
      top
      right
      color="error"
    >
      Non è possibile validare la richiesta. Il bando non è più disponibile.
    </v-snackbar>
  </div>
</template>

<script>
import mixin from '../../mixins';

export default {
  name: 'DomandeRisposteComponent',
  props: {
    domandeConRisposte: {
      type: Array,
      required: true
    },
    stato: {
      type: String,
      default: 'started'
    },
    // tastoContinuaVisibile: {
    //   type: Boolean,
    //   default: true
    // }
  },
  data() {
    return {
      risposteCorrette: {}, // domanda.uid: risposta

      risposteUtenteGrezze: {}, // Risposte "grezze" fornite dall'utente, verranno poi corrette in base alla tipologia per il confronto e inserite in risposteUtenteFinali
      risposteUtenteFinali: {}, // Risposte corrette fornite dall'utente

      schermataAttuale: 1, // Alcune domande vanno mostrate in schermate specifiche
      schermataMassima: 1, // Inizialmente è 1
      checkboxBloccantiSchermataAttuale: false, // True se sono presenti delle checkbox bloccanti nella schermata attuale

      // Per mostrare le varie snackbar
      campiNonValidatiSnackbar: false, // Mostra la snackbar in caso di campi validate_text in cui non si è premuto il tasto di Convalida con successo
      validateTextVerificatoCorrettamente: false,
      dialogConfermaInvioIsmea: false,
      erroriNelleRisposteSnackbar: false,
      simulazioneNonPartitaSnackbar: false,
    }
  },
  mounted() {
    this.inizializzazioneDomandeRisposte();
  },
  watch: {
    domandeConRisposte: { // Per gli aggiornamenti della props dal parent (se cambiano le domande aggiorno l'uid e le risposte corrette)
      handler(nuoveDomande, vecchieDomande) {
        if((!vecchieDomande || vecchieDomande.length == 0) && nuoveDomande.length > 0) // Inizializzo solo se c'è stato un cambiamento effettivo nel numero di domande
          this.inizializzazioneDomandeRisposte();
      },
      deep: true,
      immediate: true
    },
    risposteUtenteGrezze: {
      handler(nuoveRisposte, vecchieRisposte) {
        // Quando cambia una risposta grezza ritrasformo le risposteGrezze in risposteFinali:
        this.setRisposteUtenteFinaliDaGrezze()
      },
      deep: true // Nota: le proprietà di risposteUtenteGrezze vanno inizializzate con this.$set(..) per renderle reattive
    },
    schermataAttuale() {
      this.$emit('aggiorna-schermata-attuale-e-massima', {attuale: this.schermataAttuale, massima: this.schermataMassima});
    }
  },
  methods: {
    inizializzazioneDomandeRisposte(){ // Funzione che effettua operazioni preliminari
      // Inizializzo le risposte corrette
      this.risposteCorrette = {};
      this.risposteUtenteGrezze = {};
      this.risposteUtenteFinali = {};

      // this.schermataAttuale = 1;
      this.$set(this, 'schermataAttuale', 1); // Rende reattivo il cambiamento
      this.schermataMassima = 1; // Resetto le schermate massime e la ricalcolo nel forEach

      this.domandeConRisposte.forEach((domandaConRisposte, indice) => {
        // Nota: impostando qui risposteCorrette, risposteUtenteGrezze e ..Finali, esse avranno lo stesso ordine di domandeConRisposte

        if(domandaConRisposte.schermata > this.schermataMassima)
          this.schermataMassima = domandaConRisposte.schermata;

        // domandaConRisposte.uid = this.generaUID(); // Per ogni domanda genero un UID
        // Come UID provo ad utilizzare banalmente l'indice invece:
        domandaConRisposte.uid = indice;

        this.risposteCorrette[domandaConRisposte.uid] = domandaConRisposte.risposte[0];

        // Inizializzo anche le risposteUtenteFinali e grezze (in modo che abbiano lo stesso ordine delle domande):
        if (domandaConRisposte.tipo == 'checkbox' || 
            domandaConRisposte.tipo == 'checkbox_bloccante' || 
            domandaConRisposte.tipo == 'summary'
        ) {
          this.$set(this.risposteUtenteGrezze, domandaConRisposte.uid, false); // Il set rende l'associazione reattiva
          this.$set(this.risposteUtenteFinali, domandaConRisposte.uid, false);

          if(domandaConRisposte.tipo == 'checkbox_bloccante' && domandaConRisposte.schermata == this.schermataAttuale){
            this.checkboxBloccantiSchermataAttuale = true;
            this.$emit('aggiorna-checkbox-bloccanti-schermata-attuale', this.checkboxBloccantiSchermataAttuale);
          }

        } else if (domandaConRisposte.tipo == 'checkbox_reverse') {
            this.$set(this.risposteUtenteGrezze, domandaConRisposte.uid, true); // inizia come già spuntata
            this.$set(this.risposteUtenteFinali, domandaConRisposte.uid, true); // inizia come già spuntata
        } else {
          this.$set(this.risposteUtenteGrezze, domandaConRisposte.uid, "");
          this.$set(this.risposteUtenteFinali, domandaConRisposte.uid, "");
        }

        if(domandaConRisposte.tipo == 'validate_text'){
          this.$set(domandaConRisposte, 'rispostaValidata', false);
        }
          
        this.$set(domandaConRisposte, 'rispostaNonCorretta', false);

        // Dopodiche eseguo lo shuffle delle risposte per mostrarle all'utente in modi sempre diversi:
        // Però eseguo lo shuffle solo se le risposte sono di tipo array
        if (Array.isArray(domandaConRisposte.risposte) && domandaConRisposte.risposte.length > 1) {
          domandaConRisposte.risposteShuffled = this.shuffleArray(domandaConRisposte.risposte);
        }
      });

      // Invio al parent l'informazione iniziale delle schermate (per mostrare/nascondere il comportamento dei pulsanti Avanti/Indietro)
      this.$emit('aggiorna-schermata-attuale-e-massima', {attuale: this.schermataAttuale, massima: this.schermataMassima});
    },

    // La seguente funzione trasforma le risposte grezze in finali (e quindi pronte per il confronto)
    setRisposteUtenteFinaliDaGrezze(){
      this.domandeConRisposte.forEach((domandaConRisposte, indice) => {
        if (domandaConRisposte.tipo == 'data' && moment(this.risposteUtenteGrezze[domandaConRisposte.uid], "YYYY-MM-DD", true).isValid()) {
          this.risposteUtenteFinali[domandaConRisposte.uid] = moment(this.risposteUtenteGrezze[domandaConRisposte.uid], "YYYY-MM-DD").format('DD/MM/YYYY');
        } else if(domandaConRisposte.tipo == 'checkbox' || domandaConRisposte.tipo == 'checkbox_bloccante'){
          this.risposteUtenteFinali[domandaConRisposte.uid] = this.risposteUtenteGrezze[domandaConRisposte.uid]; // Un booleano
        } else if(domandaConRisposte.tipo == 'reverse'){ // reverse = l'utente deve aver inserito la stringa scritta al contrario
          this.risposteUtenteFinali[domandaConRisposte.uid] = this.risposteUtenteGrezze[domandaConRisposte.uid].split("").reverse().join("");
        } else if(domandaConRisposte.tipo == 'summary') { // Il tipo summary ha una checkbox che dev'essere sempre spuntata per andar avanti
          this.risposteUtenteFinali[domandaConRisposte.uid] = this.risposteUtenteGrezze[domandaConRisposte.uid]; // Un booleano
        } else { // Le altre tipologie sono concatenabili (quindi concateno parti statiche o altri pezzi per ottenere la stringa finale)
          this.risposteUtenteFinali[domandaConRisposte.uid] = this.ottieniRispostaUtenteConcatenata(domandaConRisposte.uid);
        }
      });

      this.$emit('aggiorna-risposte-utente', this.risposteUtenteFinali); // Invia dati al parent
    },

    // Divide la stringa in parti statiche (tra graffe) e parti editabili
    ottieniPartiStringa(stringa) {
      const regex = /{(.*?)}|([^{}]+)/g;
      const parti = [];
      let match;
      while ((match = regex.exec(stringa)) !== null) {
        if (match[1]) {
          parti.push({ traGraffeQuindiStatico: true, contenuto: match[1] });
        } else if (match[2]) {
          parti.push({ traGraffeQuindiStatico: false, contenuto: match[2] });
        }
      }
      return parti;
    },

    ottieniRispostaUtenteConcatenata(domandaUID){
      // Dal momento che possono esistere parti statiche che l'utente non deve inserire ma che fanno parte della risposta,
      // utilizzo i ref per ottenere la risposta completa concatenata

      // Attenzione: quando si cambia schermata i riferimenti possono venire persi

      let riferimentiRispostaUtente = this.$refs[domandaUID]

      if(riferimentiRispostaUtente == undefined || riferimentiRispostaUtente == null) return "";

      // Concatenazione dei valori di span e input
      let rispostaUtenteConcatenata = Array.from(riferimentiRispostaUtente)
        .map(el => {
          if (el.tagName === "INPUT") {
            if (el.type === "checkbox" || el.type === "radio") {
              return el.checked ? el.value : ""; // Prendi il valore solo se selezionato
            }
            return el.value; // Altri input (es. text)
          } else if (el.tagName === "SELECT") {
            return el.value; // Prendi il valore del select
          } else {
            return el.textContent; // Altrimenti usa il testo
          }
        })
        .join("");

      return rispostaUtenteConcatenata;
    },
    ottieniRispostaCorrettaSenzaDivisoriStatici(domandaUID){
      // Elimino eventuali divisori { e } che indicano campi statici non inseribili dall'utente, e restituisco questa come rispostaCorretta
      // Es: {AA}BB{CC} diventa AABBCC:
      let rispostaCorretta = this.risposteCorrette[domandaUID];

      if (typeof rispostaCorretta === "string")
        return rispostaCorretta.replace(/[{}]/g, "");
      else 
        return rispostaCorretta
    },

    vaiASchermata(schermata){
      this.$set(this, 'schermataAttuale', schermata); // Rende reattivo il cambiamento

      this.controllaCheckboxBloccantiSchermataAttuale();
    },

    vaiAvanti(){
      this.vaiASchermata(this.schermataAttuale+1);
    },
    vaiIndietro(){
      this.vaiASchermata(this.schermataAttuale-1);
    },

    controllaCheckboxBloccantiSchermataAttuale(){
      this.checkboxBloccantiSchermataAttuale = false;

      this.domandeConRisposte
        .filter(domanda => domanda.schermata == this.schermataAttuale)
        .some(domanda => {
          if (domanda.tipo == 'checkbox_bloccante' && (this.risposteUtenteGrezze[domanda.uid] === false || this.risposteUtenteGrezze[domanda.uid] == 'off')) {
            this.checkboxBloccantiSchermataAttuale = true;
            return true;
          }
        });
        
        this.$emit('aggiorna-checkbox-bloccanti-schermata-attuale', this.checkboxBloccantiSchermataAttuale);
    },

    // Il parent o direttamente questo componente controlleranno le risposte prima di andare avanti e inviare al server
    controllaRisposte() {
      let erroreTrovato = false;
	    let schermataInCuiHoTrovatoIlPrimoErrore = null;

      this.domandeConRisposte.some((domandaConRisposte, indice) => {
        // Se c'è anche solo un campo 'validate_text' non Convalidato (ma compilato), non permette di proseguire (mostrando snackbar di errore ma non il punto da correggere):
        if(domandaConRisposte.tipo == 'validate_text' && !domandaConRisposte.rispostaValidata && (this.risposteUtenteFinali[domandaConRisposte.uid] && this.risposteUtenteFinali[domandaConRisposte.uid] != '')){
          this.campiNonValidatiSnackbar = true;
          return true; // Interrompe il some(..)
        }
        // ============================================

        // Controllo la correttezza delle risposte:
        let rispostaCorretta = this.ottieniRispostaCorrettaSenzaDivisoriStatici(domandaConRisposte.uid);

        if (rispostaCorretta != this.risposteUtenteFinali[domandaConRisposte.uid]) {
          erroreTrovato = true;
          this.$set(domandaConRisposte, 'rispostaNonCorretta', true);
          
          if (schermataInCuiHoTrovatoIlPrimoErrore === null) {
            schermataInCuiHoTrovatoIlPrimoErrore = domandaConRisposte.schermata;
          }
        } else {
          this.$set(domandaConRisposte, 'rispostaNonCorretta', false);
        }
      })

      // Se trovo un errore torno alla schermata dell'errore
      if(erroreTrovato){
        this.vaiASchermata(schermataInCuiHoTrovatoIlPrimoErrore);

        // this.erroriNelleRisposteSnackbar = true; // In base al bando non è prevista la snackbar che avvisa

        // Risetto le checkbox ai valori di default
        this.domandeConRisposte
					.filter(domanda => domanda.schermata >= schermataInCuiHoTrovatoIlPrimoErrore)
					.forEach(domanda => {
						if (domanda.tipo == 'checkbox'
							|| domanda.tipo == 'checkbox_bloccante'
							|| domanda.tipo == 'summary'
						) {
							this.risposteUtenteGrezze[domanda.uid] = false;
						}
						else if (domanda.tipo == 'checkbox_reverse') {
							this.risposteUtenteGrezze[domanda.uid] = true;
						}
					});
				
				return false; // Risposte non corrette. Non inviare al Server
      } else {
        return true; // Risposte corrette. Il parent può procedere all'invio al Server
      }
    },

    // Restituisce true se il tipo di domandaConRisposte non richiede etichetta separata
    nonRichiedeEtichetta(tipo) {
      return ['checkbox', 'checkbox_bloccante', 'checkbox_reverse', 'summary'].includes(tipo);
    },
    // Genera i dati di riepilogo per una domandaConRisposte di tipo "summary"
    datiRiepilogo() {
      // Mappa domande con risposte in un array di oggetti dove una voce è la domanda e l'altra la risposta:
      return this.domandeConRisposte.map(domandaConRisposte => ({
        domanda: domandaConRisposte.domanda,
        rispostaUtenteFinale: this.risposteUtenteFinali[domandaConRisposte.uid]
      }));
    }
  }
}
</script>

<style lang="scss" scoped>
  @import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;500;600;700&display=swap');

	* {
		font-family: 'Open Sans', sans-serif !important;
	}

	::v-deep {
		.v-input--checkbox label {
			color: black !important;
			font-size: 14px !important;
			font-family: 'Open Sans', sans-serif !important;
		}
	}

  .body {
    min-width: 489.1px;
    max-width: 1366px;
    width: auto;
    margin-right: auto;
    margin-left: auto;
    font-size: 14.4333px;
		background-color: white;
  }
  footer {
    //position: absolute;
    //bottom: 0;
    //left: 0;
    width: 100%;
    background-color: #002e5f;
    padding: 20px 60px 20px;
    color: #fff;
    font-size: .9em;
  }
  #logo-inail {
    margin-left: 60px;
    margin-bottom: 40px;
    display: block;
  }
  #logo-inail img {
    width: 240px;
  }
  h1 {
    display: none
  }
  h2 {
    margin-top: 0;
  }
  h3 {
    margin: 0;
    margin-bottom: 30px;
    text-transform: uppercase;
    font-weight: 400;
    font-size: 16.5px;
  }
  h4 {
    font-size: 1.25em;
    margin-top: 10px;
    margin-bottom: 25px;
    font-weight: 500;
    line-height: 1.1;
  }
  fieldset {
    margin: 0;
    padding: 0;
    border: 0;
  }
  p {
    margin-bottom: 10px;
  }
  header {
    padding-top: 48px;
    // border-bottom: 20px solid #002e5f;
  }
  .main {
    // border-top: 20px solid #1E6665;
    padding-top: 5px;
    padding-left: 40px;
    padding-right: 40px;
    padding-bottom: 60px;
  }
  .main h2 {
    color: #D6A72F;
    margin-bottom: 30px;
    font-family: 'Open Sans semibold', sans-serif;
    font-size: 23.8333px;
    font-weight: 500;
  }
  .mr-15 {
      margin-right: 15px;
  }
  .form-gray {
    background-color: #EFEFEF;
    padding: 35px 30px;
  }
  .form-elem {

    margin-bottom: 20px;
  }
  .form-elem .msg {
    position: relative;
    top: 5px;
    display: none;
  }
  .form-elem input:not([type="checkbox"]):not([type="radio"]),
  //.form-elem label,
  .form-elem select {
    width: 100%;
    border: 1px solid #afafaf;
    background-color: #fff;
    height: 34px;
    box-sizing: border-box;
    padding: 6px 12px;
  }
  .form-elem input:focus,
  .form-elem select:focus {
    outline: 0;
    border-color: #66afe9;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 8px rgba(102, 175, 233, .6);
  }
  .form-elem label {
    margin-bottom: 5px;
    display: inline-block;
	  color: black;
  }
  .form-elem.errore .msg {
    display: block;
  }
  .form-elem.errore input:focus,
  .form-elem.errore select:focus {
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 6px #ce8483;
  }
  .form-elem.errore input,
  .form-elem.errore select {
    border-color: #c9291b !important;
    /* border-color: #C9291B; */
  }
  .form-elem.errore label,
  .testo-errore {
    color: #c9291b ;
    /* color: #C9291B; */
  }
  .form-elem.date-elem label {
    display: block;
  }
  .form-elem.date-elem input{
      width: 200px;
  }
  .btn {
    background-color: #002e5f;
    color: #fff;
    text-transform: uppercase;
    border-radius: 0;
    border: 0;
    min-width: 160px;
    font-weight: 400;
    padding: 6px 12px;
    line-height: 1.92857em;
    cursor: pointer;
    &.abbandona {
      background-color: #bc2025;
    }
    &.dati-personali {
      background-color: #e6901c;
    }
	  &.btn-green {
		  background-color: #0e821a;
	  }
  }
  //.btn-row {
    //height: 40px;
    //margin-top: 40px;
  //}
  .btn[disabled] {
    pointer-events: none;
    cursor: not-allowed;
    box-shadow: none;
    background: #d2d2d2;
    border-color: #d2d2d2;
    color: #002e5f;
    opacity: 1 !important;
  }

  .btn:focus,
  input[type=checkbox]:focus, .feedback:focus {
    outline: thin dotted;
    outline-offset: -2px;
  }
  input[type=checkbox] {
    margin: 0;
    margin-right: 5px;
    top: 3px;
    position: relative;
  }
  .pull-right {
    float: right;
  }
  .xs-12 {
    width: 100%;
  }

  ::v-deep ._radio_group label,
  ::v-deep ._checkbox label {
    animation: none !important;
  }

  /*SM*/
  @media (min-width: 768px) {}
  /*MD*/
  @media (min-width: 992px) {
    //.md-3 {
    //    width: 25%;
    //}
    .md-6 {
       width: 50%;
      //width: 100%;
    }
  }

  /*LG*/
  @media (min-width: 1200px) {}
  .loader-overlay {
    position: fixed;
    background-color: #002E5F;
    background-color: rgba(0, 46, 95, 0.2);
    width:100%;
    height:100%;
    top:0;
    left: 0;
    opacity: 1;
    z-index: 500000;
  }
  .loader-overlay span{
    position: fixed; /* or absolute */
    top: 50%;
    left: 50%;
    border: 10px solid #106CDB; /* Light grey */
    border-top: 10px solid #002e5f; /* Blue */
    border-radius: 50%;
    width: 60px;
    height: 60px;
    animation: spin 2s linear infinite;
  }
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
  .data-summary strong {
      width: 200px;
      display: inline-block;
  }

  .avviso-finale-prova {
    position: absolute;
    bottom: 200px;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .page-overlay {
    position: absolute;
    top:0;
    right:0;
    bottom:0;
    left:0;
    background-color: rgba(0, 0, 0, 0.50);
  }

  .tour-2-3 {
    width: 100%;
  }
  @media (min-width: 992px) {
    .tour-2-3 {
      width: 50%;;
    }
  }

  .ok-button-wrapper {
    display: flex;
    justify-content: flex-end;
    padding-top: 20px;
  }
  .ok-button {
    color: #002e5f;
    font-size: 20px;
    text-decoration: none;
    padding: 5px 10px;
    background-color: white;
    border-radius: 3px;
  }

  input[type="button"] {
    font-weight: bold;
  }
</style>
